import { navigateToUrl, pathToActiveWhen } from "single-spa";
import {
  RouteConfig,
  RoutingConfig,
  SingleSpaBeforeRoutingEvent,
} from "../models/Models";

import jwt_decode, { JwtPayload } from "jwt-decode";

export const addBeforeRoutingEventListener = (
  routes: RoutingConfig,
  logger: Console
) => {
  window.addEventListener(
    "single-spa:before-routing-event",
    (event: SingleSpaBeforeRoutingEvent) => {
      const urlMatch: any[] = Object.entries(routes.routeMappings).find(
        ([key, _val]: [string, RouteConfig]) => {
          const activeWhen = pathToActiveWhen(key, true);
          return activeWhen(
            new URL(event.detail.newUrl) as unknown as Location
          );
        }
      );

      if (urlMatch && urlMatch.length !== 0) {
        const matchedRoute: RouteConfig = urlMatch[1];
        const jwtValue: string = window.sessionStorage.getItem("JWT");
        const jwtToken: JwtPayload = jwtValue
          ? jwt_decode(jwtValue)
          : undefined;
        const reqAuth: boolean = matchedRoute.requiresAuth;
        let isLoggedIn: boolean = false;

        if (jwtToken?.exp && reqAuth) {
          isLoggedIn = Date.now() <= jwtToken.exp * 1000;
        }

        if (!isLoggedIn && reqAuth) {
          document.title =
            routes.routeMappings[routes.meta.authenticatorPath].pageTitle;
          logger.log(
            "Not logged in but you should be. Redirecting you to authentication page....."
          );
          navigateToUrl(routes.meta.authenticatorPath);
        } else {
          document.title = matchedRoute.pageTitle;
          logger.log(
            "Already logged in or authentication not required for this route so navigation is permitted."
          );
        }
      }
    }
  );
};
